module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-400.f29d2b8559699b6beb5b29b25b8bc572.woff";